module.exports = __webpack_public_path__ + "static/media/invite-now.ab9b361c.png";